import React, { useState } from 'react'
import { Box } from "@mui/material"
import ApplicationSteps from './ApplicationSteps'
import Contract from './Contract'
import ApplicationDetails from './ApplicationDetails'
import { useSelector } from 'react-redux'


export default function Application() {
    
    const data = useSelector((state) => state.AdminData.admin)
    const [FlowCount, setFlowCount] = useState(1)
    const [email, setEmail] = useState(data?.userName || "")



    return (
        <>
            <Box>
                {FlowCount == 1 && <ApplicationSteps FlowCount={FlowCount} email={email} setEmail={setEmail} setFlowCount={setFlowCount} />}
                {FlowCount == 2 && <ApplicationDetails email={email} setFlowCount={setFlowCount} />}
                {FlowCount == 3 && <Contract setFlowCount={setFlowCount} />}
            </Box>
        </>
    )
}
